export default __webpack_public_path__ + "static/search-left-top-84635a2e7ca4d25524181066e8eb7978.png";